var _path;

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgWarningTriangleRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.263 4.56a2 2 0 013.384 0l6.016 9.55c.838 1.332-.119 3.066-1.693 3.066H3.94c-1.574 0-2.531-1.734-1.693-3.066l6.016-9.55zm1.692 2.878c.512 0 .927.415.927.927v2.782a.927.927 0 11-1.854 0V8.365c0-.512.415-.927.927-.927zm0 6.028a.928.928 0 100 1.855.928.928 0 000-1.855z",
    fill: "#FF3B30"
  })));
}

export default SvgWarningTriangleRed;